// --------------------------------------------------------------------------
// quicklinkToggle.js
// --------------------------------------------------------------------------
// Simple toggle for quicklinks on mobile
// --------------------------------------------------------------------------

EC.quicklinkToggle = function () {

    'use strict';

    function init () {
        $('.js-quicklink-toggle').on('click', toggleLinks)
    }

    function toggleLinks(){
        const $trigger = $(this);
        $trigger.toggleClass('e-toggle-trigger--is-open');
        $trigger.siblings('.b-quicklink-menu__content').slideToggle();
    }

    return {
        init: init
    };

}();